import { render, staticRenderFns } from "./PhanLoaiVanBang.vue?vue&type=template&id=4dcacf63&scoped=true&"
import script from "./PhanLoaiVanBang.vue?vue&type=script&lang=js&"
export * from "./PhanLoaiVanBang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcacf63",
  null
  
)

export default component.exports